var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"definition-box"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.definitionTitle)}}),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.definitionText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }